const SESSION_CLOSED_KEY = '__session_closed';

export function initSessionGuard(): void {
  const remembered = localStorage.getItem('auth-remember-me');
  if (remembered === 'false') {
    const wasClosed = sessionStorage.getItem(SESSION_CLOSED_KEY);
    const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
    // if tab reopens, logout for sessionStorage due to browser native behaviour
    const isRestore = wasClosed && navEntry?.type !== 'reload';

    if (isRestore) {
      sessionStorage.removeItem('auth-storage');
    }
  }

  sessionStorage.removeItem(SESSION_CLOSED_KEY);

  const controller = new AbortController();
  window.addEventListener(
    'beforeunload',
    () => {
      sessionStorage.setItem(SESSION_CLOSED_KEY, 'true');
      controller.abort();
    },
    { signal: controller.signal },
  );
}
